/* IPERTECH 2026 — CART DRAWER v4 (FASE 10: auto-swap tier + delta animation) */
(function(){
  'use strict';
  var W = window, D = document;

  function ready(fn){ D.readyState !== 'loading' ? fn() : D.addEventListener('DOMContentLoaded', fn); }

  ready(function(){
    var root = D.querySelector('[data-ipt-cart]');
    if(!root) return;
    init(root);
  });

  function init(root){
    var ovl = root.querySelector('[data-ipt-cart-ovl]');
    var drawer = root.querySelector('[data-ipt-cart-drawer]');
    var closeBtn = root.querySelector('[data-ipt-cart-close]');
    var threshold = parseInt(root.getAttribute('data-free-ship-threshold') || '0', 10);
    var lastCart = null;

    /* ---- OPEN / CLOSE ---- */
    function open(){
      drawer.classList.add('is-open');
      if(ovl) ovl.classList.add('is-open');
      D.body.classList.add('ipt-cart-open');
      refresh();
    }
    function close(){
      drawer.classList.remove('is-open');
      if(ovl) ovl.classList.remove('is-open');
      D.body.classList.remove('ipt-cart-open');
    }

    if(closeBtn) closeBtn.addEventListener('click', close);
    if(ovl) ovl.addEventListener('click', close);
    D.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    D.addEventListener('click', function(e){
      var t = e.target.closest('[data-ipt-cart-open]');
      if(!t) return;
      e.preventDefault();
      open();
    });

    /* ---- INTERCETTA CLICK su [data-ipt-pp-atc] ---- */
    D.addEventListener('click', function(e){
      var atcBtn = e.target.closest('[data-ipt-pp-atc]');
      if(!atcBtn || atcBtn.disabled) return;
      var form = atcBtn.closest('form.ipt-pp__form, form[data-ipt-add-form]');
      if(!form) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      submitAdd(form);
    }, true);

    D.addEventListener('submit', function(e){
      var form = e.target;
      if(!form.matches('form.ipt-pp__form, form[data-ipt-add-form]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      submitAdd(form);
    }, true);

    /* ---- HELPERS ---- */
    function formatMoney(cents){
      if(cents === null || cents === undefined) return '';
      try {
        return new Intl.NumberFormat('it-IT', {style:'currency', currency:'EUR'}).format(cents / 100);
      } catch(ex){
        return '€' + (cents / 100).toFixed(2).replace('.', ',');
      }
    }
    function setLoading(on){ drawer.classList.toggle('is-loading', on); }

    function isServiceItem(it){
      return it.properties && it.properties['_ipt_service'] === 'true';
    }

    /* ---- TIERED VARIANT PARSING ---- */
    /* Parsa titoli tipo "Fino a €300", "Da €301 a €600", "Oltre €1200" → { min, max } in cents */
    function parseTierTitle(title){
      if(!title) return null;
      var t = String(title).replace(/\./g, '').replace(/\s+/g, ' ').trim();
      var m;
      /* Fino a €X */
      m = t.match(/fino a\s*[€]?\s*(\d+)/i);
      if(m) return { min: 0, max: parseInt(m[1], 10) * 100 };
      /* Da €X a €Y */
      m = t.match(/da\s*[€]?\s*(\d+)\s*a\s*[€]?\s*(\d+)/i);
      if(m) return { min: parseInt(m[1], 10) * 100, max: parseInt(m[2], 10) * 100 };
      /* Oltre €X / Sopra €X / Più di €X */
      m = t.match(/(?:oltre|sopra|pi[uù] di)\s*[€]?\s*(\d+)/i);
      if(m) return { min: parseInt(m[1], 10) * 100, max: Infinity };
      return null;
    }

    /* Sceglie il variant tier giusto in base al subtotale (escluso servizi) */
    function pickTierVariant(variants, totalCents){
      if(!variants || !variants.length) return null;
      var withTiers = variants.map(function(v){
        return { variant: v, tier: parseTierTitle(v.title) };
      }).filter(function(x){ return x.tier !== null; });
      if(!withTiers.length) return variants[0];
      /* Cerca il primo tier in cui totalCents cade */
      for(var i = 0; i < withTiers.length; i++){
        var t = withTiers[i].tier;
        if(totalCents >= t.min && totalCents <= t.max) return withTiers[i].variant;
      }
      /* Fallback: variante con tier max più alto */
      withTiers.sort(function(a, b){ return b.tier.max - a.tier.max; });
      return withTiers[0].variant;
    }

    /* Aggiorna card tiered con la variant scelta in base al cart */
    function applyTieredVariant(card, cart){
      var raw = card.getAttribute('data-tier-variants');
      if(!raw) return;
      var variants;
      try { variants = JSON.parse(raw); } catch(ex){ return; }
      if(!variants || !variants.length) return;
      /* Calcola subtotale escluso servizi */
      var totalCents = 0;
      (cart.items || []).forEach(function(it){
        if(!isServiceItem(it)) totalCents += (it.final_line_price || 0);
      });
      var picked = pickTierVariant(variants, totalCents);
      if(!picked) return;
      var priceCents = Math.round(parseFloat(picked.price) * 100);
      card.setAttribute('data-variant-id', picked.id);
      card.setAttribute('data-price-cents', priceCents);
      var priceEl = card.querySelector('.ipt-cart__svc-price');
      if(priceEl) priceEl.textContent = '+ ' + formatMoney(priceCents);
    }

    /* ---- ADD TO CART (JSON-based) ---- */
    function submitAdd(form){
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      var variantId = idInput && idInput.value ? parseInt(idInput.value, 10) : null;
      var quantity = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1;
      if(!quantity || quantity < 1) quantity = 1;
      if(!variantId){ showError('Variante non selezionata'); return; }

      var props = {};
      var hasProps = false;
      form.querySelectorAll('[name^="properties["]').forEach(function(el){
        var m = el.name.match(/^properties\[(.+)\]$/);
        if(m && el.value){ props[m[1]] = el.value; hasProps = true; }
      });
      var item = { id: variantId, quantity: quantity };
      if(hasProps) item.properties = props;

      setLoading(true);
      fetch(W.routes && W.routes.cart_add_url ? W.routes.cart_add_url : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [item] })
      })
      .then(function(r){ return r.json().then(function(j){ return {ok: r.ok, status: r.status, data: j}; }).catch(function(){ return {ok: r.ok, status: r.status, data: null}; }); })
      .then(function(res){
        if(!res.ok){
          setLoading(false);
          showError((res.data && (res.data.description || res.data.message)) || ('Errore ' + res.status));
          return;
        }
        return refresh().then(function(){ open(); });
      })
      .catch(function(err){ setLoading(false); showError('Errore di rete'); console.warn('[ipt-cart] add error', err); });
    }

    /* ---- REFRESH ---- */
    function refresh(){
      setLoading(true);
      return fetch(W.routes && W.routes.cart_url ? W.routes.cart_url + '.js' : '/cart.js', {
        headers: { 'Accept': 'application/json' }
      })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        lastCart = cart;
        render(cart);
        setLoading(false);
        notify(cart);
        cleanupOrphanServices(cart);
        autoSwapTieredVariants(cart);
      })
      .catch(function(err){ setLoading(false); console.warn('[ipt-cart] refresh error', err); });
    }

    /* ---- RENDER ---- */
    function render(cart){
      var cntEl = root.querySelector('[data-ipt-cart-count]');
      if(cntEl) cntEl.textContent = cart.item_count;

      var nonSvcItems = (cart.items || []).filter(function(it){ return !isServiceItem(it); });
      var emptyEl = root.querySelector('[data-ipt-cart-empty]');
      var bodyContent = root.querySelector('[data-ipt-cart-content]');
      var footEl = root.querySelector('[data-ipt-cart-foot]');

      if(nonSvcItems.length === 0){
        if(emptyEl) emptyEl.style.display = '';
        if(bodyContent) bodyContent.style.display = 'none';
        if(footEl) footEl.style.display = 'none';
        return;
      }
      if(emptyEl) emptyEl.style.display = 'none';
      if(bodyContent) bodyContent.style.display = '';
      if(footEl) footEl.style.display = '';

      var listEl = root.querySelector('[data-ipt-cart-items]');
      if(listEl){
        listEl.innerHTML = nonSvcItems.map(renderItem).join('');
        bindItemEvents(listEl);
      }

      syncServiceCards(cart);
      renderShipping(cart);
      renderTotals(cart);
    }

    function renderItem(it){
      var img = it.featured_image && it.featured_image.url
        ? it.featured_image.url.replace(/(\.[^.?]+)(\?.*)?$/, '_128x$1$2')
        : '';
      var hasSale = it.original_line_price > it.final_line_price;
      var variant = it.variant_title && it.variant_title !== 'Default Title'
        ? '<p class="ipt-cart__it-variant">' + esc(it.variant_title) + '</p>' : '';
      var was = hasSale ? '<span class="ipt-cart__it-was">' + formatMoney(it.original_line_price) + '</span>' : '';
      return ''
        + '<li class="ipt-cart__it" data-key="' + esc(it.key) + '">'
        + (img ? '<img class="ipt-cart__it-img" src="' + esc(img) + '" alt="" loading="lazy" width="64" height="64">' : '<div class="ipt-cart__it-img"></div>')
        + '<div class="ipt-cart__it-info">'
        + '<a class="ipt-cart__it-name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>'
        + variant
        + '<div class="ipt-cart__it-controls">'
        + '<div class="ipt-cart__qty">'
        + '<button type="button" data-qty-dec aria-label="Diminuisci">−</button>'
        + '<input type="number" value="' + it.quantity + '" min="0" max="999" data-qty-input aria-label="Quantità">'
        + '<button type="button" data-qty-inc aria-label="Aumenta">+</button>'
        + '</div>'
        + '<button type="button" class="ipt-cart__it-rm" data-rm>Rimuovi</button>'
        + '</div>'
        + '</div>'
        + '<div class="ipt-cart__it-pr">'
        + '<span class="ipt-cart__it-price">' + formatMoney(it.final_line_price) + '</span>'
        + was
        + '</div>'
        + '</li>';
    }

    function bindItemEvents(listEl){
      listEl.querySelectorAll('.ipt-cart__it').forEach(function(li){
        var key = li.getAttribute('data-key');
        var input = li.querySelector('[data-qty-input]');
        var dec = li.querySelector('[data-qty-dec]');
        var inc = li.querySelector('[data-qty-inc]');
        var rm = li.querySelector('[data-rm]');
        if(dec) dec.addEventListener('click', function(){ change(key, parseInt(input.value,10) - 1); });
        if(inc) inc.addEventListener('click', function(){ change(key, parseInt(input.value,10) + 1); });
        if(input) input.addEventListener('change', function(){ change(key, parseInt(input.value,10)); });
        if(rm) rm.addEventListener('click', function(){ change(key, 0); });
      });
    }

    function change(key, qty){
      qty = Math.max(0, qty || 0);
      setLoading(true);
      fetch(W.routes && W.routes.cart_change_url ? W.routes.cart_change_url + '.js' : '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function(r){ return r.json(); })
      .then(function(){ return refresh(); })
      .catch(function(err){ setLoading(false); console.warn('[ipt-cart] change error', err); });
    }

    /* ---- SERVIZI: sync + toggle ---- */
    function syncServiceCards(cart){
      root.querySelectorAll('[data-ipt-svc]').forEach(function(card){
        /* Prima aggiorna variant tiered se applicabile */
        if(card.getAttribute('data-tiered') === 'true'){
          applyTieredVariant(card, cart);
        }
        var vid = parseInt(card.getAttribute('data-variant-id'), 10);
        /* Per tiered: match per product_id (qualsiasi variant del prodotto conta come "in cart") */
        var tieredVariants = [];
        if(card.getAttribute('data-tiered') === 'true'){
          try { tieredVariants = JSON.parse(card.getAttribute('data-tier-variants') || '[]'); } catch(ex){}
        }
        var tieredIds = tieredVariants.map(function(v){ return v.id; });
        var inCart = (cart.items || []).some(function(it){
          if(!isServiceItem(it)) return false;
          if(tieredIds.length && tieredIds.indexOf(it.variant_id) !== -1) return true;
          return it.variant_id === vid;
        });
        var check = card.querySelector('[data-ipt-svc-check]');
        if(check) check.checked = inCart;
        card.classList.toggle('is-active', inCart);
      });
    }

    /* ---- AUTO-SWAP tiered variant ---- */
    /* Se la card è tiered E in cart c'è già una variante diversa da picked, swap */
    var swappingNow = false;
    function autoSwapTieredVariants(cart){
      if(swappingNow) return;
      var swaps = [];
      root.querySelectorAll('[data-ipt-svc]').forEach(function(card){
        if(card.getAttribute('data-tiered') !== 'true') return;
        var raw = card.getAttribute('data-tier-variants');
        if(!raw) return;
        var variants;
        try { variants = JSON.parse(raw); } catch(ex){ return; }
        var tieredIds = variants.map(function(v){ return v.id; });
        /* Trova il service item attualmente in cart (qualsiasi variant del tier set) */
        var currentItem = (cart.items || []).find(function(it){
          return isServiceItem(it) && tieredIds.indexOf(it.variant_id) !== -1;
        });
        if(!currentItem) return;
        /* Calcola il variant corretto in base al subtotale */
        var totalCents = 0;
        (cart.items || []).forEach(function(it){
          if(!isServiceItem(it)) totalCents += (it.final_line_price || 0);
        });
        var picked = pickTierVariant(variants, totalCents);
        if(!picked || picked.id === currentItem.variant_id) return;
        swaps.push({ oldKey: currentItem.key, newVariantId: picked.id });
      });
      if(!swaps.length) return;
      swappingNow = true;
      /* Esegui swap: remove old, add new */
      var promise = Promise.resolve();
      swaps.forEach(function(s){
        promise = promise
          .then(function(){
            return fetch(W.routes && W.routes.cart_change_url ? W.routes.cart_change_url + '.js' : '/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: s.oldKey, quantity: 0 })
            });
          })
          .then(function(r){ return r.json(); })
          .then(function(){
            return fetch(W.routes && W.routes.cart_add_url ? W.routes.cart_add_url : '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: s.newVariantId, quantity: 1, properties: { _ipt_service: 'true' } }] })
            });
          })
          .then(function(r){ return r.json(); });
      });
      promise.then(function(){ swappingNow = false; refresh(); })
             .catch(function(err){ swappingNow = false; console.warn('[ipt-cart] tier swap error', err); });
    }

    /* ---- DELTA ANIMATION ---- */
    function showDelta(card, cents, isAdding){
      var float = D.createElement('div');
      float.className = 'ipt-cart__delta-float' + (isAdding ? '' : ' is-negative');
      float.textContent = (isAdding ? '+ ' : '− ') + formatMoney(Math.abs(cents));
      card.style.position = 'relative';
      card.appendChild(float);
      setTimeout(function(){ float.remove(); }, 900);
      /* Pulse sul totale */
      var totEl = root.querySelector('[data-ipt-cart-total]');
      if(totEl){
        totEl.classList.remove('is-pulse');
        void totEl.offsetWidth;
        totEl.classList.add('is-pulse');
        setTimeout(function(){ totEl.classList.remove('is-pulse'); }, 500);
      }
    }

    /* ---- AUTO-CLEANUP orphan services ---- */
    /* Se ci sono solo service items in cart (nessun prodotto reale), rimuovi i servizi */
    function cleanupOrphanServices(cart){
      var nonSvc = (cart.items || []).filter(function(it){ return !isServiceItem(it); });
      var svc = (cart.items || []).filter(isServiceItem);
      if(nonSvc.length === 0 && svc.length > 0){
        var updates = {};
        svc.forEach(function(it){ updates[it.key] = 0; });
        fetch(W.routes && W.routes.cart_update_url ? W.routes.cart_update_url + '.js' : '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function(r){ return r.json(); }).then(function(c){
          lastCart = c;
          render(c);
        }).catch(function(err){ console.warn('[ipt-cart] orphan cleanup error', err); });
      }
    }

    function bindServiceEvents(){
      root.querySelectorAll('[data-ipt-svc]').forEach(function(card){
        var check = card.querySelector('[data-ipt-svc-check]');
        if(!check) return;

        card.addEventListener('click', function(e){
          if(e.target === check || e.target.closest('label')) return;
          check.checked = !check.checked;
          check.dispatchEvent(new Event('change'));
        });

        check.addEventListener('change', function(){
          var vid = parseInt(card.getAttribute('data-variant-id'), 10);
          if(!vid) return;
          if(check.checked){
            addService(vid, card);
          } else {
            removeService(vid, card);
          }
        });
      });
    }

    function addService(variantId, card){
      card.classList.add('is-active');
      setLoading(true);
      var priceCents = parseInt(card.getAttribute('data-price-cents'), 10) || 0;
      showDelta(card, priceCents, true);
      fetch(W.routes && W.routes.cart_add_url ? W.routes.cart_add_url : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _ipt_service: 'true' } }] })
      })
      .then(function(r){ return r.json(); })
      .then(function(){ return refresh(); })
      .catch(function(err){
        setLoading(false);
        card.classList.remove('is-active');
        var check = card.querySelector('[data-ipt-svc-check]');
        if(check) check.checked = false;
        console.warn('[ipt-cart] service add error', err);
      });
    }

    function removeService(variantId, card){
      if(!lastCart) return;
      /* Per tiered: il variantId corrente potrebbe essere diverso da quello effettivamente in cart */
      var allowedIds = [variantId];
      if(card && card.getAttribute('data-tiered') === 'true'){
        try {
          var tv = JSON.parse(card.getAttribute('data-tier-variants') || '[]');
          allowedIds = tv.map(function(v){ return v.id; });
        } catch(ex){}
      }
      var svcItem = null;
      for(var i = 0; i < (lastCart.items || []).length; i++){
        var it = lastCart.items[i];
        if(allowedIds.indexOf(it.variant_id) !== -1 && isServiceItem(it)){ svcItem = it; break; }
      }
      if(!svcItem) return;
      card.classList.remove('is-active');
      setLoading(true);
      showDelta(card, (svcItem.final_line_price || svcItem.price || 0), false);
      fetch(W.routes && W.routes.cart_change_url ? W.routes.cart_change_url + '.js' : '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: svcItem.key, quantity: 0 })
      })
      .then(function(r){ return r.json(); })
      .then(function(){ return refresh(); })
      .catch(function(err){
        setLoading(false);
        card.classList.add('is-active');
        var check = card.querySelector('[data-ipt-svc-check]');
        if(check) check.checked = true;
        console.warn('[ipt-cart] service remove error', err);
      });
    }

    /* ---- SHIPPING BAR ---- */
    function renderShipping(cart){
      var shipEl = root.querySelector('[data-ipt-cart-ship]');
      if(!shipEl || threshold <= 0) return;
      var totalCents = cart.total_price;
      var thresholdCents = threshold * 100;
      var remaining = thresholdCents - totalCents;
      var pct = Math.min(100, Math.round(totalCents / thresholdCents * 100));
      var fill = shipEl.querySelector('[data-ipt-cart-ship-fill]');
      var msg = shipEl.querySelector('[data-ipt-cart-ship-msg]');
      if(fill) fill.style.width = pct + '%';
      var truckSvg = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h13v8H3zM16 10h4l2 3v2h-6zM5.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM18.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" stroke="currentColor" fill="none" stroke-width="1.7" stroke-linejoin="round"/></svg>';
      if(remaining <= 0){
        shipEl.classList.add('is-unlocked');
        if(msg) msg.innerHTML = truckSvg + ' <b>Spedizione gratuita</b> sbloccata!';
      } else {
        shipEl.classList.remove('is-unlocked');
        if(msg) msg.innerHTML = truckSvg + ' Aggiungi ancora <b>' + formatMoney(remaining) + '</b> per la <b>spedizione gratuita</b>';
      }
    }

    /* ---- TOTALS ---- */
    function renderTotals(cart){
      var subEl = root.querySelector('[data-ipt-cart-sub]');
      var savEl = root.querySelector('[data-ipt-cart-saving]');
      var totEl = root.querySelector('[data-ipt-cart-total]');
      var savRow = root.querySelector('[data-ipt-cart-saving-row]');
      if(subEl) subEl.textContent = formatMoney(cart.items_subtotal_price || cart.total_price);
      if(totEl) totEl.textContent = formatMoney(cart.total_price);
      var saving = (cart.original_total_price || 0) - (cart.total_price || 0);
      if(saving > 0){
        if(savRow) savRow.style.display = '';
        if(savEl) savEl.textContent = '− ' + formatMoney(saving);
      } else {
        if(savRow) savRow.style.display = 'none';
      }
    }

    /* ---- ERROR TOAST ---- */
    function showError(msg){
      var t = D.createElement('div');
      t.textContent = msg;
      t.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);background:#dc2626;color:#fff;padding:10px 18px;border-radius:8px;z-index:10000;font-size:14px;font-weight:500;box-shadow:0 4px 14px rgba(0,0,0,.2);font-family:var(--ipt-font,sans-serif)';
      D.body.appendChild(t);
      setTimeout(function(){ t.style.opacity = '0'; t.style.transition = 'opacity .3s'; setTimeout(function(){ t.remove(); }, 300); }, 2800);
    }

    /* ---- PUB/SUB ---- */
    function notify(cart){
      try { W.dispatchEvent(new CustomEvent('ipt-cart:updated', { detail: { cart: cart } })); } catch(ex){}
      D.querySelectorAll('[data-cart-count],.ipt-hdr__a-d').forEach(function(b){
        if(b.matches('[data-cart-count]')) b.textContent = cart.item_count;
      });
    }

    /* ---- LEGACY UPSELL PRODOTTO ---- */
    var upsellAdd = root.querySelector('[data-ipt-cart-upsell-add]');
    if(upsellAdd){
      upsellAdd.addEventListener('click', function(){
        var id = upsellAdd.getAttribute('data-variant-id');
        if(!id) return;
        upsellAdd.disabled = true;
        setLoading(true);
        fetch(W.routes && W.routes.cart_add_url ? W.routes.cart_add_url : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
        })
        .then(function(r){ return r.json(); })
        .then(function(){ return refresh(); })
        .catch(function(err){ console.warn('[ipt-cart] upsell error', err); })
        .finally(function(){ upsellAdd.disabled = false; });
      });
    }

    /* ---- ESCAPE helper ---- */
    function esc(s){
      if(s == null) return '';
      return String(s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; });
    }

    /* Init */
    bindServiceEvents();
    refresh();

    W.iptCart = { open: open, close: close, refresh: refresh };
  }
})();
